<template>
 <div>
   <el-drawer
    id="c8284a"
    title=""
    :visible.sync="newDialog"
    :with-header="false"
    direction="ltr"
    size="280px"
    @close="closeDialog"
    :append-to-body="true"
  >
    <div id="c5aa52" class="uf88a7">
      
      <div id="g9c54a">
      
         <div class="menu-icon margin-top20 margin-bottom20" @click="closeDialog" >
          <div class="menu-round-con" v-for="item in 3" :key="item">
            <div class="menu-round-item"></div>
            <div class="menu-round-item"></div>
            <div class="menu-round-item"></div>
          </div>
        </div>
      
      </div>
      <div id="ga563c" class="u27130">
        <div id="g60c73" class="u4b77c">{{ $t('Home.Applications') }}</div>
      </div>
      <div id="g4ded7" class="menu_box">
        <div id="gcb9c7" @click="goHome()" class="menu_box_1">
          <div style="width: 50px" class="flex_center">
            <img
              src="../../assets/images/seachCompany.png"
              alt=""
              class="headImg"
            />
          </div>
          <div id="geda81">
            <div id="g5a801" class="menu_title">{{ $t('Home.SearchCompanies') }}</div>
          </div>
        </div>
           <div id="ce5823" class="u7d321 menu_box_1 menu_box_2" v-if="true">
          <div style="width: 50px" class="flex_center">
            <img
              src="../../assets/images/SearchLeads.png"
              alt=""
              class="headImg"
            />
          </div>
          <div id="c87e85">
            <div
              id="cf3b94"
              class="uaee16 menu_title"
              @click="openUrl('/index/list/risk')"
            >
              {{ $t('Home.SearchLeads') }}
            </div>
          </div>

        </div>
        <div id="cdac66" class="u7d321 menu_box_1" v-if="true">
          <div style="width: 50px" class="flex_center">
            <img
              src="../../assets//images/SearchTrade.png"
              alt=""
              class="headImg"
            />
          </div>
          <div id="cfed6e" class="u2e886">
            <!-- @click="gotoOne('https://csibizsearch.com/#/?id=Search Trade&show=2')" -->
            <div
              id="c12ae8"
              class="uaee16 menu_title"
              @click="openUrl('/home?Detail=Trade')"
            >
            {{ $t('Home.SearchTrade') }}
            </div>
          </div>
        </div>
        <div id="c38882" class="u7d321 menu_box_1 menu_box_2" v-if="true">
          <div style="width: 50px">
            <img
              src="../../assets/images/SearchRisk.png"
              class="headImg"
              alt=""
            />
          </div>
          <div id="c7e5ec" class="u2e886">
            <div
              id="c4d0b8"
              class="uaee16 menu_title"
              @click="goPageUrl('/sanction/index?selectCode=4')"
            >
             Search Sanctions
            </div>
          </div>
        </div>
        <!-- <div id="c6d18b" class="menu_box_1" v-if="true">
          <div style="width: 50px" class="flex_center">
            <img
              src="../../assets//images//SearchCountry.png"
              alt=""
              class="headImg"
            />
          </div>
          <div id="cac2bf" class="u2e886">
            <div
              id="cbc952"
              class="menu_title"
              @click="
                gotoOne('https://csibizsearch.com/#/?id=Search Country&show=4')
              "
            >
             {{ $t('Home.SearchCountries') }}
            </div>
          </div>
        </div> -->
        <div id="cd8129" class="u7d321 menu_box_1 menu_box_2" v-if="false">
          <div style="width: 50px" class="flex_center">
            <img
              src="../../assets/images/SearchNews.png"
              alt=""
              class="headImg"
            />
          </div>

          <div id="c86239" class="uc43d5">
            <div
              id="ce8d52"
              class="uaee16 menu_title"
              @click="goPageUrl('/news/index')"
            >
            {{ $t('Home.SearchNews') }}
            </div>
          </div>
        </div>
     
          <div id="ce5823" class="u7d321 menu_box_1 menu_box_2" v-if="true">
          <div style="width: 50px" class="flex_center">
            <img
              src="../../assets/images/RisScan.png"
              alt=""
              class="headImg"
            />
          </div>
          <div id="c87e85">
            <div
              id="cf3b94"
              class="uaee16 menu_title"
              @click="reportDialog=true"
            >
            Risk Scan
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </el-drawer>
<riskdrawer :showReport="reportDialog" @closeReportDialog="closeRiskDialog($event)"
    ></riskdrawer>
 </div>
  
</template>
<script>
import riskdrawer from '../risk-drawer/riskdrawer.vue';
export default {
  name: "",

  props: {
    RouterDrawer: {
      type: Boolean,
    },
  },

  mounted() {},

  components: {
riskdrawer
  },

  data() {
    return {
                reportDialog: false,
            newDialogtwo: false,
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.RouterDrawer;
      },
      set() {},
    },
  },
  methods: {
      closeRiskDialog(value) {
        
      this.reportDialog = value;
    },
    closeDialog() {
      this.$emit("closeCloseDialog", false);
    },
    openUrl(pathUrl) {
      let keyWord =
        this.$route.query.keword == undefined ? 2 : this.$route.query.keword;

      if (pathUrl.includes("Detail")) {
        let routeData = this.$router.resolve({
          path: pathUrl,
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          path: pathUrl + "?keword=" + keyWord,
        });
        window.open(routeData.href, "_blank");
      }

      this.drawer = false;
    },
    gotoOne(value) {
      window.open(value, "_blank");
    },
    goPageUrl(path) {
      let href = window.location.origin + "#" + path;
      window.open(href, "_blank");
    },
    goHome() {
      this.$emit("closeCloseDialog", false);
      this.$router.push("/");
    },
  },
};
</script>
<style scoped>
.uf88a7 {
  /* padding-left: 1em; */
  padding-left: 0.7142857142857143rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.ufexJgR {
  margin-left: -1rem;
}

.u27130 {
  padding-left: 0.35714285714285715rem;
}

.u4b77c {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-top: 0.2rem;
  margin-top: 0.7rem;
  margin-bottom: 2rem;
  color: rgb(6, 6, 6);
  font-size: 1.714285714rem;
  font-family: "DMSans Bold";
  /* font-weight: 400; */
}

.menu_box {
  display: flex;
  /* justify-content: space-around; */
  justify-content: center;
  padding-left: 0.7142857142857143rem;
  padding-right: 0.5rem;
  flex-wrap: wrap;
}

.menu_box_1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 2rem;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  cursor: pointer;
}

.menu_title {
  padding-left: 1.4285714285714286rem;
  color: rgb(1, 1, 1);
  font-size: 1.2857rem;
}

.menu_box_2 {
  display: flex;
  justify-content: flex-start;
  /* padding-left: 1.1em; */
  overflow-y: hidden;
}

.uZ6BszV {
  margin-right: 0.8rem;
}
/* 动态九宫格 */
 .menu-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 28px;
  margin-right: 40px;
  cursor: pointer;
}
.menu-round-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-round-con .menu-round-item {
  width: 6px;
  height: 6px;
  background: rgb(6, 6, 6);
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}
  .menu-round-item {
  /* box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5); */
}
 .menu-icon:hover .menu-round-item:first-child {
  width: 100%;
  height: 4px;
}

  .menu-icon:hover
  .menu-round-item:nth-last-child(-n + 2) {
  width: 0px;
}

</style>
